import { useEffect } from 'react';
import axiosInstance from '../api/axiosConfig';
import { applyCurrencySettings } from '../utils/paymentCurrency';

export const CURRENCY_REFRESH_MS = 30000;

export default function useCurrencySync() {
  useEffect(() => {
    const controller = new AbortController();
    let pending = false;
    const refresh = async () => {
      if (pending || document.visibilityState === 'hidden' || controller.signal.aborted) return;
      pending = true;
      try {
        const response = await axiosInstance.get('/store/currencies', { cache: false, signal: controller.signal });
        if (!controller.signal.aborted && response.data?.status === 'success') applyCurrencySettings(response.data.data);
      } catch (error) {
        // Retain the last valid settings while offline and retry on the next refresh.
      } finally {
        pending = false;
      }
    };
    refresh();
    const interval = window.setInterval(refresh, CURRENCY_REFRESH_MS);
    window.addEventListener('focus', refresh);
    window.addEventListener('online', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      controller.abort();
      window.clearInterval(interval);
      window.removeEventListener('focus', refresh);
      window.removeEventListener('online', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, []);
}
